import type { ComponentType, ReactNode } from 'react'
import { Inbox, type IconProps } from './icons'

export type EmptyStateProps = {
  /** Title Case title, for example "No Order Forms Yet". */
  title: string
  /** Sentence case prose that says what appears here and how to add it. */
  description?: ReactNode
  icon?: ComponentType<IconProps>
  /** One button when the person can fill this region. */
  action?: ReactNode
  /** A smaller, left-aligned row for use inside a card. */
  compact?: boolean
  /** Heading level of the title, so it fits the page outline. */
  headingLevel?: 2 | 3 | 4
  className?: string
}

/** Shows that a region has no content yet. */
export function EmptyState({ title, description, icon: Icon = Inbox, action, compact = false, headingLevel = 3, className = '' }: EmptyStateProps) {
  const Heading = `h${headingLevel}` as 'h2' | 'h3' | 'h4'
  return (
    <div className={['ui-empty-state', compact && 'ui-empty-state--compact', className].filter(Boolean).join(' ')}>
      <span className="ui-empty-state__tile" aria-hidden="true"><Icon size={compact ? 18 : 22} /></span>
      <div className="ui-empty-state__text">
        <Heading className="ui-empty-state__title">{title}</Heading>
        {description && <p className="ui-empty-state__description">{description}</p>}
      </div>
      {action && <div className="ui-empty-state__action">{action}</div>}
    </div>
  )
}
